import { Flex } from "Element/Flex";
import styled from "styled-components";

export const FooterWrapper = styled(Flex)`
  padding: 48px 120px;
  background-color: ${({ theme }) => theme.colors.purple};
  height: 100%;

  .follow {
    ${({ theme }) => theme.fontStyle.primary}
    text-align: end;
    color: ${({ theme }) => theme.colors.neutral00};
    margin-bottom: 12px;
    ${({ theme }) => theme.mediaWidth.upToExtraSmall`
      margin-bottom: 24px;
    `}
  }

  .company {
    ${({ theme }) => theme.fontStyle.primary}

    color: ${({ theme }) => theme.colors.neutral00};
    margin-top: 12px;
    ${({ theme }) => theme.mediaWidth.upToExtraSmall`
      margin-top: 36px;
    `}
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 48px 24px;
    flex-direction: column-reverse;
      .sausage-logo {
        display: none;
      }
      .follow {
        text-align: center;
      }
  `}
`;

export const SocialMedia = styled.a`
  background-color: ${({ theme }) => theme.colors.neutral00};
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  :hover {
    svg {
      path {
        opacity: 0.5;
      }
    }
  }
  svg {
    width: 20px;
    height: 20px;
    path {
      fill: #000;
    }
  }
  :first-child {
    margin-right: 24px;
  }
  :last-child {
    margin-left: 24px;
  }
`;
